import React from 'react';
import { createRoot } from 'react-dom/client'; // 変更点：clientからcreateRootをインポート
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 1. root要素を取得
const container = document.getElementById('root');

// 2. createRootを使用してrootを作成
const root = createRoot(container);

// 3. renderメソッドを呼び出す（ReactDOM.renderは使いません）
root.render(
  <App />
);

reportWebVitals();